import { combineReducers } from 'redux'
import * as TypeAction from './actionTypes'
import { reducerCrud, reducerObj } from 'scorpion-core';

export default combineReducers({
    rCrudSalvar: reducerCrud(TypeAction.SALVAR),
    rPerfil: reducerObj(TypeAction.BUSCAR),
})


// WEBPACK FOOTER //
// ./src/routes/private/PerfilUsuario/reducer.js